/*
 * The confidentiality warning's "already seen" record (TDI-609).
 *
 * rmsRecordConfidentialWarningSeen writes confidentialWarningSeen.{uid} on
 * the patient record when a user first confirms a download for that patient.
 * Per patient record, not per pathway: a user downloading autism and ADHD
 * files for the same child sees the warning once.
 */

export const CONFIDENTIAL_WARNING_SEEN_FIELD = 'confidentialWarningSeen';

/**
 * Whether this user has already acknowledged the warning for this record.
 * Any recorded value counts (the server writes a timestamp); a missing
 * record, user or entry means the warning still shows.
 *
 * @param {object|null|undefined} patientRecord
 * @param {string|null|undefined} uid
 * @returns {boolean}
 */
export function confidentialWarningSeenBy(patientRecord, uid) {
  if (!patientRecord || !uid) return false;
  const seen = patientRecord[CONFIDENTIAL_WARNING_SEEN_FIELD];
  if (!seen || typeof seen !== 'object') return false;
  return seen[uid] != null;
}
